import { forEach, some } from 'lodash';

import type { AuthUser } from 'common/auth/types';
import type { UserGuidesStatus } from 'common/graphql/types';

export const hideOverriddenPendoTrainings = (user: AuthUser) => {
    const pendo = (window as any).pendo;

    const allActiveGuides = pendo.getActiveGuides();

    forEach(allActiveGuides, (guide) => {
        const guideIsOverridden = some(
            user?.guidesStatus,
            (userGuideStatus: UserGuidesStatus) =>
                userGuideStatus?.guideName === guide?.name && userGuideStatus?.isCompleted && !guide?.isComplete?.()
        );
        if (guideIsOverridden) {
            guide?.hide({ stayHidden: true });
        }
    });
};
